import React from 'react';
import MovdLogo from '../components/MovdLogo.jsx';
import { movdTokens } from './movdTokens.js';

// Shared centered-card shell used by every stand-alone account flow screen
// (sign in/up, verify email, set password) so they share one visual language
// instead of each page inventing its own card/header treatment.
export default function MovdAuthCard({ eyebrowAction, title, subtitle, children, notice }) {
  return (
    <div style={{ minHeight: 'calc(100vh - 64px)', background: movdTokens.color.background.canvas, padding: 'clamp(24px, 6vw, 64px) 20px', display: 'flex', alignItems: 'center', boxSizing: 'border-box' }}>
      <div style={{ maxWidth: 480, margin: '0 auto', width: '100%' }}>
        {eyebrowAction}
        <div style={{ border: `1px solid ${movdTokens.color.border.subtle}`, borderRadius: 16, overflow: 'hidden', background: movdTokens.color.surface.base, boxShadow: movdTokens.shadow.panel }}>
          <div style={{ padding: 'clamp(20px, 4vw, 36px)', background: movdTokens.color.brand.ink, color: movdTokens.color.text }}>
            <MovdLogo size="small" color="white" />
            <h1 style={{ margin: '20px 0 0', fontSize: 26, fontWeight: 900, letterSpacing: '-.02em' }}>{title}</h1>
            {subtitle && <p style={{ margin: '8px 0 0', color: 'rgba(255,255,255,.7)', lineHeight: 1.55 }}>{subtitle}</p>}
          </div>
          <div style={{ padding: 'clamp(20px, 4vw, 36px)' }}>
            {notice}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
